<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasCostType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasFoodMajorKind="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasRankType="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
      <div class="row" v-if="chartData.rows.length > 0" slot="middleArea">
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-histogram :data="chartData" :settings="chartSettings" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-table card-body">
            <ve-pie :data="chartData"></ve-pie>
          </div>
        </div>
      </div>
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      columns: [
        { name: "FoodKindNumber" },
        { name: "FoodKindName" },
        { name: "Qty" },
        { name: "Total" },
        { name: "TotalCost" },
        { name: "NTaxPrice" },
        { name: "ZTaxPrice" },
        { name: "GrossProfit" },
        { name: "GrossMargin" },
        { name: "SaleProportion" },
      ],
      chartSettings: {
        labelMap: {
          Qty: "數量",
          Total: "金額",
        },
        axisSite: { right: ["Total"] },
        yAxisType: ["normal", "KMB"],
        yAxisName: ["數量", "金額"],
      },
      chartData: {
        columns: ["FoodKindName", "Qty", "Total"],
        rows: [],
      },
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodKindStatistic(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodKindStatistic(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodKindStatistic(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getFoodKindStatistic(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
        vm.chartData.rows = data.Datas;
      });
    },
  },
};
</script>
